
import React from "react";
import { UseFormReturn } from "react-hook-form";
import { FormInput } from "@/components/FormFields/FormInput";

interface PersonalInfoFieldsProps {
  form: UseFormReturn<any>;
}

export function PersonalInfoFields({ form }: PersonalInfoFieldsProps) {
  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <FormInput
          form={form}
          name="firstName"
          label="First Name"
          placeholder="Enter your first name"
          description="Your legal first name"
          required
        />
        <FormInput
          form={form}
          name="lastName"
          label="Last Name"
          placeholder="Enter your last name"
          description="Your legal last name"
          required
        />
      </div>

      <FormInput
        form={form}
        name="email"
        label="Work Email"
        placeholder="name@company.com"
        type="email"
        description="We'll use this to follow up with you"
        required
      />

      <FormInput
        form={form}
        name="company"
        label="Company / Firm Name"
        placeholder="Enter your company or firm name"
        description="The name of your legal practice or organization"
        required
      />
    </>
  );
}
